// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".overlay-loader[data-v-9c831782]{position:fixed;top:0;left:0;z-index:501}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
